const REACT_APP_API_URL: string =
  process.env.REACT_APP_API_URL ||
  "https://api.croix-de-luisant.ch/admin-daytoday";

export const env = {
  REACT_APP_API_URL,
};
